import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { ArrowLeft } from "lucide-react";

export const BlogPost3 = () => {
  return (
    <>
      <Helmet>
        <title>Cost of Starting Tape Manufacturing Plant in India 2025 | Hero Impex</title>
        <meta name="description" content="Complete investment breakdown for BOPP tape manufacturing plant in India. Machinery costs, infrastructure, working capital. Get detailed quotation." />
      </Helmet>

      <article className="min-h-screen bg-white">
        <div className="bg-gradient-to-br from-slate-900 to-slate-800 text-white py-12">
          <div className="container mx-auto px-4 max-w-4xl">
            <Link to="/blog" className="inline-flex items-center gap-2 text-amber-400 hover:text-amber-300 mb-6">
              <ArrowLeft className="w-4 h-4" />
              Back to Blog
            </Link>
            <Badge className="mb-4 bg-amber-500">Business Planning</Badge>
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Cost of Starting a Tape Manufacturing Plant in India 2025
            </h1>
            <p className="text-xl text-slate-300">Coming Soon - Complete breakdown of investment required for BOPP tape plant setup.</p>
            <div className="mt-6 text-sm text-slate-400">Published: January 8, 2025</div>
          </div>
        </div>
        
        <div className="container mx-auto px-4 max-w-4xl py-12">
          <div className="bg-amber-50 border-l-4 border-amber-500 p-6 mb-8">
            <p className="text-slate-700">This article is currently being written. Please check back soon or contact us for detailed project quotation.</p>
          </div>
          
          <Link to="/contact">
            <Button className="bg-gradient-to-r from-amber-500 to-amber-600">
              Get Project Quotation
            </Button>
          </Link>
        </div>
      </article>
    </>
  );
};
